// extracted by css-extract-rspack-plugin
export default {"trailingRow":"ttmYemvB3Q0fkMyB","root":"SmwC3cqNbj4SrEW6","container":"SGH00YZMBY4tAwVA"};